import React, {useState} from 'react';
import {
   StyleSheet,
   View,
   Text,
   Image,
   TouchableOpacity,
   ActivityIndicator,
   Dimensions,
   Platform,
} from 'react-native';
import {
   white,
   FONT_FAMILY_REGULAR,
   ActivityLoaderColor,
} from '../../utils/utils';
//import Svg, {Defs, LinearGradient, Stop, Rect} from 'react-native-svg';
import UISvg from '../../components/svg';
import {useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';

export const BrowseListItem = ({item, navigation, emptyCard, num, index}) => {
   const isLandscapemode = useSelector(selectScreenOrientation);
   const moduleLevel =
      item.ModuleCount +
      ' ' +
      (item.ModuleCount === 1 ? ' Module' : ' Modules');
   const hour = Math.round((item.Duration / 60) * 100) / 100;
   const hourLevel = hour + ' ' + (hour === 1 ? 'Hour' : 'Hours');
   const pn = item.Key;
   const [loading, setLoading] = useState(true);
   const isModuleCountHoursVisible =
      item.ModuleCount > 0 || item.Duration > 0 ? true : false;

   const handleImageLoad = () => {
      setLoading(false);
   };
   const [hover, setHover] = React.useState(false);
   /**
    * @Empty Card Container
    * @Style properties
    */
   const containerStyle = [
      styles.cardContainer,
      {
         height: isLandscapemode ? 250 : 200,
         width: isLandscapemode ? '32%' : null,
         ...Platform.select({
            web: {
               width: null,
               flexDirection: !isLandscapemode ? 'row' : null,
               maxWidth: isLandscapemode ? '33.33%' : null,
               justifyContent: 'space-between',
               margin: isLandscapemode ? 8 : 0,
            },
            android: {
               marginTop: isLandscapemode ? 2 : null,
               marginHorizontal: isLandscapemode ? 2 : null,
               padding: isLandscapemode ? 2 : null,
               paddingBottom: null,
               margin: 3,
            },
         }),
      },
   ];
   /**
    * @Grid Content Card
    * @Style properties
    */
   const containerGridStyle = [
      styles.cardContainer,
      {
         height: isLandscapemode ? 250 : 200,
         borderRadius: isLandscapemode ? 10 : 8,
         width: isLandscapemode ? '98%' : null,
         ...Platform.select({
            web: {
               width: isLandscapemode ? '100%' : null,
               maxWidth: isLandscapemode ? '100%' : null,
               margin: isLandscapemode ? 0 : 4,
            },
            android: {
               backgroundColor: '#CCC',
            },
         }),
      },
   ];
   /**
    * @Empty Card UI
    */
   const EmptyCardUI = () => (
      <View style={containerStyle}>
         <View style={containerGridStyle} />
      </View>
   );
   return (
      <>
         <TouchableOpacity
            style={containerStyle}
            onMouseEnter={() => {
               setHover(true);
            }}
            onMouseLeave={() => {
               setHover(false);
            }}
            onStartShouldSetResponder={() => false}
            onResponderStart={() => {
               //this.setStyles(activeStyle)
            }}
            onResponderRelease={() => {
               //this.setStyles(this.state.hover ? hoverStyle : style)
            }}
            onPress={() => {
               navigation.navigate('CourseDescriptionScreen', {
                  navigation: navigation,
                  item: item,
               });
            }}>
            <View style={containerGridStyle}>
               {loading && (
                  <ActivityIndicator
                     size="small"
                     color={ActivityLoaderColor}
                     style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 1,
                     }}
                  />
               )}
               <Image
                  source={{
                     uri:
                        /* 'https://cdn.norcat.org/assets/img/catalogue/jpg/' + */
                        item.Thumbnail,
                  }}
                  style={styles.cardBackgroundImage}
                  onLoad={handleImageLoad}
               />
               <View style={styles.cardContent}>
                  <UISvg
                     height="100%"
                     width="100%"
                     x1="0%"
                     y1="100%"
                     x2="0%"
                     y2="0%"
                     offset={['30%', '100%']}
                     stopColor={['#000', '#000']}
                     stopOpacity={[hover ? '0.5' : '0.8', hover ? '0' : '0.1']}
                  />
                  <View
                     style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        width: '100%',
                        padding: 9,
                     }}>
                     <Text
                        style={{
                           fontSize: 14,
                           color: white,
                           fontFamily: FONT_FAMILY_REGULAR,
                           fontWeight: '700',
                           marginRight: 10,
                        }}>
                        {' '}
                        {item.moduleLevel}
                     </Text>
                  </View>
                  <View
                     colors={['#20202000', '#CC202020', '#CC202020']}
                     style={styles.courseTitleDetails}>
                     {/* <Svg
                     height="100%"
                     width="100%"
                     style={StyleSheet.absoluteFillObject}>
                     <Defs>
                        <LinearGradient
                           id="grad"
                           x1="0%"
                           y1="0%"
                           x2="0%"
                           y2="100%">
                           <Stop
                              offset="0%"
                              stopColor="rgba(81, 83, 82, 0.5)"
                              stopOpacity="0"
                           />
                           <Stop
                              offset="100%"
                              stopColor="#141414"
                              stopOpacity="1"
                           />
                        </LinearGradient>
                     </Defs>
                     <Rect width="100%" height="100%" fill="url(#grad)" />
                  </Svg> */}
                     <UISvg
                        height="100%"
                        width="100%"
                        x1="0%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                        offset={['0%', '100%']}
                        stopColor={['rgba(81, 83, 82, 0.5)', '#141414']}
                        stopOpacity={['0', '1']}
                     />
                     <Text
                        style={[
                           styles.courseTitle,
                           {
                              marginBottom: isLandscapemode ? 20 : 6,
                           },
                        ]}>
                        {item.Name}
                     </Text>
                     {isModuleCountHoursVisible ? (
                        <View
                           style={{
                              flexDirection: 'row',
                              marginLeft: 16,
                              marginBottom: 16,
                           }}>
                           <View
                              style={{
                                 flexDirection: 'row',
                                 alignItems: 'center',
                              }}>
                              <Image
                                 source={require('../../assets/course_hightlight_24.png')}
                                 style={{
                                    width: 10,
                                    height: 10,
                                    resizeMode: 'contain',
                                 }}
                              />
                              <Text
                                 style={{
                                    fontSize: isLandscapemode ? 12 : 8,
                                    fontWeight: '400',
                                    fontFamily: FONT_FAMILY_REGULAR,
                                    color: 'white',
                                    marginLeft: 5,
                                    marginRight: 8,
                                 }}>
                                 {' '}
                                 {moduleLevel}
                              </Text>
                           </View>

                           <View
                              style={{
                                 flexDirection: 'row',
                                 alignItems: 'center',
                              }}>
                              <Image
                                 source={require('../../assets/Timer.png')}
                                 style={{
                                    width: 10,
                                    height: 10,
                                    resizeMode: 'contain',
                                 }}
                              />
                              <Text
                                 style={{
                                    fontSize: isLandscapemode ? 12 : 8,
                                    fontWeight: '400',
                                    fontFamily: FONT_FAMILY_REGULAR,
                                    color: 'white',
                                    marginLeft: 5,
                                    marginRight: 8,
                                 }}>
                                 {hourLevel}
                              </Text>
                           </View>
                        </View>
                     ) : (
                        <View
                           style={{
                              flexDirection: 'row',
                              marginLeft: 14,
                              marginBottom: 16,
                           }}>
                           <View
                              style={{
                                 flexDirection: 'row',
                                 alignItems: 'center',
                              }}>
                              <Text
                                 style={{
                                    fontSize: isLandscapemode ? 12 : 8,
                                    fontWeight: '400',
                                    fontFamily: FONT_FAMILY_REGULAR,
                                    color: 'white',
                                    textAlign: 'left',
                                 }}>
                                 {' '}
                                 {'Practical Training'}
                              </Text>
                           </View>
                        </View>
                     )}
                  </View>
               </View>
            </View>
         </TouchableOpacity>
         {emptyCard > 0 && num > 0 && num - 1 === index && <EmptyCardUI />}
         {emptyCard > 1 && num > 0 && num - 1 === index && <EmptyCardUI />}
      </>
   );
};

const styles = StyleSheet.create({
   cardContainer: {
      overflow: 'hidden',
      width: '100%',
      // height: 200,
      margin: 3,
      flex: 1,
   },
   cardBackgroundImage: {
      position: 'absolute',
      resizeMode: 'cover',
      width: '100%',
      height: '100%',
   },
   cardContent: {
      width: '100%',
      height: '100%',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
   },
   courseTitle: {
      marginLeft: 16,
      marginRight: 16,
      fontSize: 14,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginBottom: 6,
      marginTop: 12,
   },

   courseTitleDetails: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      minHeight: 70,
      // backgroundColor: 'rgba(0, 0, 0, 0.5)',
   },
});
